import Cookies from 'js-cookie'

const TokenKey = 'crm_login_key'
const TokenExpiresAtKey = 'crm_login_expires_at'
const LegacyDingPasswordRequiredKey = 'ding_password_required'
const UserSessionStorageKeys = [
  'loginUserInfo',
  'clickCustomerInfo',
  'clickCaseInfo',
  'clickContractInfo',
  'clickLetterForm',
  'editLetterForm',
  'visitCustomer',
  'editVisitRow',
  'contract_receivables_list',
  'customerTabNum',
  'caseTabNum',
  'contractTabNum',
  LegacyDingPasswordRequiredKey
]

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, expiresIn) {
  const expiresInSeconds = Number(expiresIn)
  if (!Number.isFinite(expiresInSeconds) || expiresInSeconds <= 0) {
    throw new Error('登录凭证有效期无效')
  }

  const expiresAt = Date.now() + expiresInSeconds * 1000
  const cookieOptions = {
    expires: new Date(expiresAt),
    path: '/'
  }

  Cookies.set(TokenExpiresAtKey, String(expiresAt), cookieOptions)
  return Cookies.set(TokenKey, token, cookieOptions)
}

export function removeToken() {
  Cookies.remove(TokenExpiresAtKey, { path: '/' })
  return Cookies.remove(TokenKey, { path: '/' })
}

/**
 * 清理 CRM 会话相关数据，避免误删钉钉之外的持久配置。
 */
export function clearUserSessionStorage(preserveRedirect = false) {
  UserSessionStorageKeys.forEach(key => localStorage.removeItem(key))
  if (!preserveRedirect) {
    localStorage.removeItem('redirectUrl')
  }
}

/**
 * 清理旧版本遗留的“禁止钉钉自动登录”标记。
 */
export function clearLegacyDingLoginState() {
  localStorage.removeItem(LegacyDingPasswordRequiredKey)
}

/**
 * 统一计算登录成功后的默认落点，保留现有特殊账号规则。
 */
export function getDefaultLandingPath(userInfo) {
  return Number(userInfo && userInfo.id) === 1137 ? '/customer/index' : '/home'
}
